import styled from '@emotion/styled'

import FeatureBoxBase, * as FeatureBox from '@segment/matcha/components/FeatureBox'

import ColumnTrack from '@segment/matcha/components/ColumnTrack'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'

import MaturityModelImage from './MaturityModelImage'

const data = [
  {
    heading: `Getting started`,
    description: `Your data is fragmented, slow, and untrustworthy`,
    color: `#D9D7DB`,
  },
  {
    heading: `Developing`,
    description: `You collect data reliably, understand it, and act on it`,
    color: `#E12811`,
  },
  {
    heading: `Leading`,
    description: `Data drives your KPIs and growth strategy`,
    color: `#EA9F5A`,
  },
  {
    heading: `Visionary`,
    description: `You lead your category with data-driven user experiences`,
    color: `#52BD95`,
  },
]

const MaturityModel = () => (
  <StyledSection variant="2Col">
    <SectionCopy alignSelf="center">
      <ColumnTrack columns={1}>
        {data.map(({ heading, description, color }) => (
          <StyledFeatureBox key={heading} alignment="left" color={color}>
            <FeatureBox.Body>
              <FeatureBox.Title variant="h4">{heading}</FeatureBox.Title>
              <FeatureBox.Text>{description}</FeatureBox.Text>
            </FeatureBox.Body>
          </StyledFeatureBox>
        ))}
      </ColumnTrack>
    </SectionCopy>
    <Section.Contents>
      <MaturityModelImage />
    </Section.Contents>
  </StyledSection>
)

const StyledSection = styled(SectionBase)`
  ${Section.Wrapper} {
    padding-top: 0;

    ${({ theme }) => theme.breakpoints.down(`md`)} {
      grid-template-areas:
        'contents'
        'copy';
    }
  }
`

const SectionCopy = styled(Section.Copy)`
  max-width: 440px;

  ${({ theme }) => theme.breakpoints.up(`lg`)} {
    justify-self: end;
  }
`

type FeatureBoxProps = {
  color: string
}

const StyledFeatureBox = styled(FeatureBoxBase)<FeatureBoxProps>`
  border-left: 4px solid ${({ color }) => color};
  padding-left: 20px;
`

export default MaturityModel
